



const pluginsConfig = {};

export default pluginsConfig;
